import { useState } from 'react';
import BeingTemplateEditor from './BeingTemplateEditor.js';
import ProvisionTemplateEditor from './ProvisionTemplateEditor.js';
export default function TemplateEditor({ masterTypes, aogYear }) {
  const [tab, setTab] = useState('Being');
  return <><div className="app-tabs" role="tablist" aria-label="Template kind">{['Being', 'Provision'].map(kind => <button key={kind} type="button" role="tab" aria-selected={tab === kind} className={`app-tab ${tab === kind ? 'active' : ''}`} onClick={() => setTab(kind)}>{kind}</button>)}</div>
    <div hidden={tab !== 'Being'} role="tabpanel" aria-label="Being Templates"><BeingTemplateEditor masterTypes={masterTypes} aogYear={aogYear} active={tab === 'Being'} /></div>
    <div hidden={tab !== 'Provision'} role="tabpanel" aria-label="Provision Templates"><ProvisionTemplateEditor masterTypes={masterTypes} active={tab === 'Provision'} /></div>
  </>;
}
